export function average(iterable, property)
{
	let values = iterable.map(property);
	let sum = values.reduce((p, c) => p + c, 0);
	return sum / values.length;
}